import { render, staticRenderFns } from "./CreateNewBudget.vue?vue&type=template&id=8c6ba4ea&scoped=true"
import script from "./CreateNewBudget.vue?vue&type=script&lang=js"
export * from "./CreateNewBudget.vue?vue&type=script&lang=js"
import style0 from "./CreateNewBudget.vue?vue&type=style&index=0&id=8c6ba4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6ba4ea",
  null
  
)

export default component.exports